import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { Member } from '../../../../../types/entity.types';

import { ACTIVE } from '../../../../../utils/constants';
import { getClassNames } from '../../../../../utils/util';

import TribeMembers from '../tribe-members/TribeMembers';

import TribeHashtagsContainer from '../../../../../containers/programme/tribe/tribe-hashtags/TribeHashtags.container';

import './tribe-info.scss';

type Props = {
  status: string;
  pendingApprovals?: number;
  members: Member[];
  fullWidth?: boolean;
};

const TribeInfo = ({ status, pendingApprovals, members, fullWidth = false }: Props) => {
  const [searchParams] = useSearchParams();

  const hasSubProgrammes = searchParams.get('hasSubProgrammes') === 'true';

  return (
    <div className={getClassNames('tribe__info', { 'full-width': fullWidth })}>
      {status === ACTIVE && (
        <Link to={`approvals?hasSubProgrammes=${hasSubProgrammes}`}>
          <div className="tribe__approval-button">
            <p className="tribe__approval-button__message">POSTS/COMMENTS AWAITING APPROVAL</p>
            <div className="tribe__approval-button__icon">
              <p>{pendingApprovals ? pendingApprovals : 0}</p>
            </div>
          </div>
        </Link>
      )}
      <div className="tribe__info__scroll-container">
        <TribeMembers members={members} />
        <TribeHashtagsContainer />
      </div>
    </div>
  );
};

export default TribeInfo;
